import { Comment } from "../../../entities/comment";
import CommentRepository from "../../ports/commentRepository";

export type updateCommentUsecase = (
  applicantId: string,
  id: string,
  data: Comment[]
) => Promise<void>;

export const buildUpdateComment = (dependencies: {
  commentRepo: CommentRepository;
}): updateCommentUsecase => {
  const { commentRepo } = dependencies;

  const updateComment: updateCommentUsecase = async (
    applicantId: string,
    id: string,
    data: Comment[]
  ) => commentRepo.updateComment(applicantId, id, data);

  return updateComment;
};
